export default "__VITE_ASSET__51f420e5__"